import { Component, OnInit } from '@angular/core';
import { AlertController, NavParams, PopoverController } from '@ionic/angular';
import { FotosService } from 'src/app/servicios/fotos/fotos.service';

@Component({
  selector: 'app-dedicatoria',
  templateUrl: './dedicatoria.component.html',
  styleUrls: ['./dedicatoria.component.scss'],
})

export class DedicatoriaComponent implements OnInit {

  maxcaracteres: number = 200;
  cantcaracteres: number = 0;

  constructor(public alertCtrl: AlertController, public fotosService: FotosService, public poper: PopoverController, public  navParams: NavParams ) { 
    console.log(navParams.get('dedicatoria'));
    let dedicatoriaData = navParams.get('dedicatoria');
    this.dedicatoria = JSON.stringify(dedicatoriaData);
    console.log("dedicatoria en componente: ", this.dedicatoria);
  }

  ngOnInit() {}
  Mifrase;
  auxFrase;
  frase(event){
    this.auxFrase = event.detail.value;
    this.dedicatoria = this.auxFrase;
    this.cantcaracteres = this.auxFrase.length;
    }
  dedicatoria: string = '';

  async aceptarPopOver(){
    this.Mifrase = this.auxFrase;
    this.fotosService.dedicatoria = this.Mifrase; 
    this.poper.dismiss({   
         dedicatoria: this.Mifrase
    });
  }

 async cancelarPopOver(){
  this.poper.dismiss(); 
 }

  async cerarPopOver(){  
    this.poper.dismiss(); 
  }
}
